import React, { Component } from 'react'
import { connect } from 'react-redux';

class DocumentTypes extends Component{


    render(){
        return(
            <div>
                count
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
        dataList: state.datahub.dataList,
    }
}

export default connect(mapStateToProps)(DocumentTypes);


// WEBPACK FOOTER //
// ./src/components/layouts/documentTypes/documentTypes.js